
import { StripeCustomerToken } from './../../models/stripe-customer-token.model';
import {OnInit, Component, Input} from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { environment } from './../../../environments/environment';

import { ConfirmOrder } from './../../models/confirm-order.model';
import { Order } from './../../models/order.model';
import { OrderResult } from './../../models/order-result.model';
import { StripeRequest } from './../../models/stripe-request.model';

import { OrderService } from './../../services/site/order.service';
import { ToastrService } from 'ngx-toastr';
import { UserService } from './../../services/site/user.service';

@Component({
    selector: 'app-stripe-payment',
    templateUrl: './stripe-payment.component.html',
    styleUrls: ['./stripe-payment.component.scss'],
})
export class StripePaymentComponent implements OnInit {

    @Input() sessionOrder: ConfirmOrder;

    order: Order;
    savedOrder: OrderResult;
    sourceToken: string;
    isSubmitted = false;

    constructor(
      private router: Router,
      private orderService: OrderService,
      private toastrService: ToastrService,
      private userService: UserService
    ) { }

    ngOnInit() {
        this.loadStripe();
    }

    loadStripe() {
      if (!window.document.getElementById('stripe-script')) {
        const s = window.document.createElement('script');
        s.id = 'stripe-script';
        s.type = 'text/javascript';
        s.src = 'https://checkout.stripe.com/checkout.js';
        window.document.body.appendChild(s);
      }
    }

    saveOrder() {
      console.log('saveOrder');
      const currentUser = sessionStorage.getItem('currentUser');
      if (currentUser === undefined || currentUser === null) {
        sessionStorage.setItem('redirectUrl', '/orders/confirmation');
        this.router.navigate(['/login']);
        return;
      }

      // The order total is calculated by the API after this component is rendered, so the
      // order can still be incomplete when the button is pressed. Posting it in that state
      // used to fail server side with an unhelpful "Order could not be created".
      const validationError = this.getOrderValidationError();
      if (validationError !== null) {
        this.toastrService.error(validationError);
        return;
      }

      this.isSubmitted = true;
      const user = JSON.parse(currentUser);
      const order = this.buildOrderRequest(user);

      console.log('stripe-payment: Creating order in database');
      console.log('saveOrder-sessionOrder: ' + JSON.stringify(order));

      this.orderService.createOrder(order)
        .subscribe(data => {
          console.log('stripe-payment-saveOrder');
          this.savedOrder = data;
          if (data && data.orderID > 0) {
            console.log('stripe-payment: Proceeding to collect order payment');
            const orderTotal = Number(Number(order.orderTotal).toFixed(2));
            console.log('orderTotal: ' + orderTotal);

            this.pay(data.orderID, orderTotal, order.billTo.emailAddress, order.accountId);
          } else {
            console.log('stripe-payment: Order not saved');
            this.toastrService.error(this.getServerErrorMessage(data));
          }
          this.isSubmitted = false;
        }, error => {
          this.toastrService.error('Order Error: ' + error);
          this.isSubmitted = false;
        });
    }

    // The order returned by /orders/totals is serialized by the API as userID/accountID,
    // so assigning userId/accountId straight onto it would leave two spellings of the same
    // field in the request body. Build the request explicitly instead.
    private buildOrderRequest(user: any): ConfirmOrder {
      return new ConfirmOrder({
        billTo: this.sessionOrder.billTo,
        shipTo: this.sessionOrder.shipTo,
        orderDetails: this.sessionOrder.orderDetails,
        lineItems: this.sessionOrder.lineItems,
        subTotal: this.sessionOrder.subTotal,
        salesTax: this.sessionOrder.salesTax,
        shippingTotal: this.sessionOrder.shippingTotal,
        orderTotal: this.sessionOrder.orderTotal,
        identifier: this.sessionOrder.identifier,
        userId: user.userID,
        accountId: user.accountID
      });
    }

    private getOrderValidationError(): string {
      if (!this.sessionOrder || !this.sessionOrder.billTo || !this.sessionOrder.shipTo) {
        return 'Your order is not ready yet. Please wait for the order total to finish calculating.';
      }
      if (!this.sessionOrder.lineItems || this.sessionOrder.lineItems.length === 0) {
        return 'Your cart is empty.';
      }
      if (this.sessionOrder.orderTotal === undefined || this.sessionOrder.orderTotal === null) {
        return 'Your order total has not been calculated yet. Please wait a moment and try again.';
      }
      return null;
    }

    private getServerErrorMessage(result: OrderResult): string {
      if (result && result.errors && result.errors.length > 0) {
        return 'Order could not be created: ' + result.errors.join(', ');
      }
      return 'Order could not be created';
    }

    test() {
      console.log('passed-token: ' + this.sourceToken);
    }

    chargeOrder(orderTotal: number, orderId: number, email: string, token: string) {
      console.log('chargeOrder');
      const stripeRequest = new StripeRequest({
        orderTotal,
        orderID: orderId,
        emailAddress: email,
        sourceToken: token
      });
      console.log('charge-order: orderTotal: ' + orderTotal);
      this.userService.saveStripeCharge(stripeRequest)
        .subscribe(data => {
          console.log('chargeOrder data: ' + JSON.stringify(data));
          if (data.captured) {
            this.toastrService.success('Stripe charge successful');
          } else {
            this.toastrService.error('Stripe charge failed - ' + data.failureMessage);
          }

        });
    }

    updateCustomerToken(accountId: number, token: string) {
      console.log('updateCustomerToken');
      const request = new StripeCustomerToken({
        accountId,
        sourceToken: token
      });

      this.userService.updateCustomerToken(accountId, request)
        .subscribe(data => {
          this.toastrService.success('Updated customer token successfully');
        });

    }

    pay(orderId: number, orderTotal: any, email: string, accountId: number) {
      console.log('pay');
      let submittedForm = false;
      console.log('stripePublicKey: ' + environment.stripePublicKey);
      console.log('pay-orderTotal: ' + orderTotal);
      const handler = (window as any).StripeCheckout.configure({
        key: environment.stripePublicKey,
        locale: 'auto',
        // Arrow function so `this` stays bound to the component rather than the config object.
        token: (token: any) => {
          // You can access the token ID with `token.id`.
          // Get the token ID to your server-side code for use.
          console.log('token: ' + JSON.stringify(token));
          this.sourceToken = token.id;
          console.log('stripe-payment-sourceToken: ' + this.sourceToken);
          submittedForm = true;

          const stripeOrder = {
            orderId,
            orderTotal,
            email,
            accountId,
            token: token.id
          };
          console.log('stripeOrder: ' + JSON.stringify(stripeOrder));
          sessionStorage.setItem('stripe-charge', JSON.stringify(stripeOrder));
          window.location.href = '/orders/payment';
        }
      });

      handler.open({
        name: 'TFC Order',
        description: 'Order #' + orderId ,
        amount: Math.round(Number(orderTotal) * 100),
        closed() {
          console.log('closed payment dialog');
        }
      });


    }
}
